/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Icon component.
 */
export const SystemMapIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.1096 8.03125H2.5C2.22386 8.03125 2 8.25511 2 8.53125V16.2643C2 16.5405 2.22386 16.7643 2.5 16.7643H13.1096C13.3857 16.7643 13.6096 16.5405 13.6096 16.2643V8.53125C13.6096 8.25511 13.3857 8.03125 13.1096 8.03125Z' stroke={iconColor} strokeWidth='1.5' />
      <path d='M16.7247 16.3448C17.6013 16.1205 18.3777 15.6096 18.9304 14.8933C19.4832 14.177 19.7806 13.2965 19.7753 12.3917C19.77 11.487 19.4623 10.61 18.9012 9.90019C18.3401 9.19041 17.5578 8.6886 16.6787 8.47461' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M18.0488 18.8177C19.4732 18.4485 20.7336 17.6145 21.6305 16.448C22.5273 15.2814 23.0093 13.8489 23.0001 12.3775C22.9908 10.9061 22.4909 9.47979 21.5795 8.32459C20.668 7.1694 19.3972 6.35133 17.9683 6' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default SystemMapIcon;
